<template lang="pug">
  .how-to-v2.row.xs-f-small.max-at-tweak
    .steps.xs-12(v-if="steps && steps.length")
      ul.step-list.xs-f-small.max-at-tweak
        li.step.xs-f-small.max-at-tweak(v-for="step in steps")
          span.step-title.capitalize.brand-color-1.block.xs-f-small.max-at-tweak {{ step.title }}
          span.step-text.text-color-3.block.xs-f-xsmall.max-at-tweak {{ step.text }}

    .video-wrap.xs-12(v-if="defaultVideo")
      video.how-to-video.full-width(v-if="defaultVideo && !isPurePigment" :src="defaultVideo.url" :poster="defaultVideo.video_thumb" :alt="defaultVideo.alt_text" controls="true" aria-label="How To Color Your Hair")

</template>

<script>
  import { mapState, mapGetters } from "vuex";

  export default {
    name: "HowToV2",

    computed: {
      ...mapState('cms', ['cmsSettings']),
      ...mapGetters('pdp', ['isPurePigment']),

      steps() {
        return this.cmsSettings?.ProductDetailsHowTo?.steps || null;
      },

      defaultVideo() {
        return this.cmsSettings?.ProductDetailsHowTo?.defaultVideo || null;
      },
    }
  };
</script>

<style scoped lang="stylus">
  .how-to-v2
    padding-bottom 1.5em
    
    .steps
      .step
        padding-bottom 1em
        
</style>
